import { useMutation } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { getAccessToken } from "../../api/getAccessToken";
import { bonusAdminBody } from "./bonusAdminBody";
import type { CampaignIn } from "../../components/Promotions/DynamicBonuses/types";
import type { TestSendResult } from "./useTestSendCampaign";

export type DraftTestSendVariables = {
  campaign: CampaignIn;
  recipients: string[];
};

async function postDraftTestSend({
  campaign,
  recipients,
}: DraftTestSendVariables): Promise<TestSendResult> {
  const instance = createPrivateAdminPanelInstance(getAccessToken());
  const response = await instance.post(API_ROUTES.TEST_SEND_DRAFT_DYNAMIC_BONUS_CAMPAIGN, {
    campaign,
    recipients,
  });
  const result = bonusAdminBody<TestSendResult>(response);
  if (!result) {
    throw new Error("Empty test-send response");
  }
  return result;
}

export const useTestSendDraftCampaign = () =>
  useMutation<TestSendResult, Error, DraftTestSendVariables>({
    mutationFn: postDraftTestSend,
  });
